/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

import { axiosServer } from './setup';

export async function getStrings (lang) {
  const server = axiosServer();
  const response = await server.get('getstrings.php', {
    params: {
      lang: lang
    }
  });
  let strings = {};
  if (
    response &&
    response.data &&
    response.data.strings &&
    response.data.strings.EM_LANG &&
    response.data.strings.EM_CURR_LANG
  ) {
    strings = response.data.strings;
  }
  return strings;
}
